import * as Sentry from "@sentry/react";
import { getSentryDsn, isDevEnvironment } from "./env/runtimeEnv";

const sentryDsn = getSentryDsn();

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: isDevEnvironment ? "development" : "production",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    tracesSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.2,
    tracePropagationTargets: ["localhost", "https://tujus-pwa-dev.web.app"],
    sendDefaultPii: true,
    enableLogs: true,
    debug: process.env.NODE_ENV === "development",
  });
} else {
  console.warn("Sentry DSN missing; tracing and error reporting are disabled. TEST");
}
